import React  from "react";
import { useParams } from 'react-router-dom';
import FarmParcelForm from "./components/FarmParcelForm";

const ViewFarmParcel = () => {
	const { farmerinformationId, farmparcelId } = useParams();
	return (
	    <div>
	    	<div className="mt-5 grid h-full grid-cols-1 gap-4">
	      		<FarmParcelForm farmerId={farmerinformationId} recordId={farmparcelId} mode="view"/>
	      </div>
	    </div>
    );
};

export default ViewFarmParcel;